import React from 'react'
// ##
import OrdersTable from '../../modules/Order/components/OrdersTable'

export default function OrdersPage() {
  return <OrdersTable />
}
